import logo from "@/assets/logo.webp";
import logoWhite from "@/assets/logo-white.webp";

const SOCIAL = [
  { emoji: "📷", label: "Instagram", href: "https://www.instagram.com/mrpanda.gr" },
  { emoji: "👍", label: "Facebook", href: "https://www.facebook.com/mrpanda.gr" },
  { emoji: "✉️", label: "info@mrpanda.gr", href: "mailto:info@mrpanda.gr" },
  { emoji: "📞", label: "2311 822 500", href: "tel:+302311822500" },
];

export function ComingSoon({ message }: { message?: string | null }) {
  return (
    <div className="mp-playful-panel relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden px-6 py-12 text-center">
      {/* Floating playful emojis */}
      <span className="pointer-events-none absolute left-[8%] top-[14%] animate-float-y text-4xl opacity-70 sm:text-5xl" aria-hidden>
        🎋
      </span>
      <span className="pointer-events-none absolute right-[10%] top-[18%] animate-bob text-3xl opacity-70 sm:text-4xl" aria-hidden>
        ✨
      </span>
      <span className="pointer-events-none absolute bottom-[16%] left-[14%] animate-bob text-3xl opacity-60 sm:text-4xl" aria-hidden>
        🎈
      </span>
      <span className="pointer-events-none absolute bottom-[12%] right-[12%] animate-float-y text-4xl opacity-60 sm:text-5xl" aria-hidden>
        🛍️
      </span>

      <div className="relative z-10 flex max-w-xl flex-col items-center">
        <img
          src={logo}
          alt="MrPanda.gr"
          width={360}
          height={95}
          className="mb-6 h-20 w-[303px] object-contain animate-bob sm:h-24 sm:w-[364px] dark:hidden"
        />
        <img
          src={logoWhite}
          alt="MrPanda.gr"
          width={360}
          height={95}
          className="mb-6 hidden h-20 w-[303px] object-contain animate-bob sm:h-24 sm:w-[364px] dark:block"
        />

        <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-sm font-semibold text-primary">
          🐼 MrPanda.gr
        </div>

        <h1 className="text-balance text-4xl font-extrabold tracking-tight text-foreground sm:text-6xl">
          Σύντομα κοντά σας!
        </h1>

        <p className="mt-4 max-w-md text-pretty text-base text-muted-foreground sm:text-lg">
          {message?.trim()
            ? message
            : "Ετοιμάζουμε κάτι παιχνιδιάρικο και υπέροχο για εσάς. Το νέο μας eshop έρχεται πολύ σύντομα — μείνετε συντονισμένοι! 🎉"}
        </p>

        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          {SOCIAL.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target={s.href.startsWith("http") ? "_blank" : undefined}
              rel={s.href.startsWith("http") ? "noopener noreferrer" : undefined}
              className="inline-flex items-center gap-2 rounded-full border border-input bg-background/70 px-4 py-2 text-sm font-medium text-foreground backdrop-blur transition-all hover:-translate-y-0.5 hover:border-primary/50 hover:text-primary"
            >
              <span aria-hidden>{s.emoji}</span>
              {s.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}